import { useState } from 'react';
import { Check, Link } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ShareButtonProps {
  className?: string;
  getShareUrl?: () => string;
}

export function ShareButton({ className, getShareUrl }: ShareButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleShare = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    const urlToShare = getShareUrl ? getShareUrl() : window.location.href;
    
    // Copy URL to clipboard
    navigator.clipboard.writeText(urlToShare).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      console.error('Failed to copy URL:', err);
    });
  };

  return (
    <button
      onClick={handleShare}
      className={cn(
        "absolute top-2 right-2 p-1.5 rounded-full bg-background/80 backdrop-blur-sm border border-border/50 shadow-sm hover:bg-muted transition-all z-10 group",
        copied ? "text-green-500 border-green-500/30 bg-green-500/10" : "text-muted-foreground hover:text-foreground",
        className
      )}
      title="Copy link to this view"
    >
      {copied ? (
        <Check className="w-3.5 h-3.5" />
      ) : (
        <Link className="w-3.5 h-3.5" />
      )}
    </button>
  );
}

